/**
 * LandingPage, EmailContact
 */
export const INPUT_EMAIL = "INPUT_EMAIL";
export const INPUT_SUBJECT = "INPUT_SUBJECT";
export const INPUT_BODY = "INPUT_BODY";

/**
 * FXculator
 */
export const INPUT = "INPUT";
export const CURRENCY_TO_UPDATE = "CURRENCY_TO_UPDATE";
export const UPDATE_ALL_CURRENCY_LIST = "UPDATE_ALL_CURRENCY_LIST";
export const SELECT_NEW_CURRENCY = "SELECT_NEW_CURRENCY";
export const FX_RATE = "FX_RATE";
export const FX_ALL_RATES = "FX_ALL_RATES";
export const FX_AMOUNT = "FX_AMOUNT";
export const OUTPUT_CALCULATOR = "OUTPUT_CALCULATOR";
export const INPUT_CALCULATOR = "INPUT_CALCULATOR";

 /**
  * DevSpace
  */
export const REMAIN_SECONDS = "REMAIN_SECONDS";
export const TIMEOUT_ID = "TIMEOUT_ID";
export const SESSION_INCREASE = "SESSION_INCREASE";
export const SESSION_DECREASE = "SESSION_DECREASE";
export const BREAK_INCREASE = "BREAK_INCREASE";
export const BREAK_DECREASE = "BREAK_DECREASE";

/**
 * Quotes Box
 */
export const QUERY_RANDOM_QUOTE_SUCCESS="QUERY_RANDOM_QUOTE_SUCCESS";
export const QUERY_RANDOM_QUOTE_FAIL="QUERY_RANDOM_QUOTE_FAIL";

